import { combineReducers } from 'redux-immutablejs';

import appReducer from '@modules/app/AppReducer';
import sketchReducer from '@modules/sketch/reducers';
import ciReducer from '@modules/ci/reducers';
import biReducer from '@modules/bi/reducers';
import litigationReducer from '@modules/litigation/reducers';
import assessmentReducer from '@modules/assessment/reducers';
import appraisalReducer from '@modules/appraisal/reducers';
import appraisalAdminReducer from '@modules/appraisalAdmin/reducers';
import processManagerReducer from '@modules/processManager/reducers';
import eventsReducer from '@modules/events/reducers';
import mraReducer from '@modules/mra/reducers';
import analysisReducer from '@modules/analysis/reducers';
import dataCaptureReducer from '@modules/dataCapture/reducers';
import auditsReducer from '@modules/audits/reducers';
import appealsReducer from '@modules/appeals/reducers';
import queueReducer from '@modules/queue/reducers';
import mobileReducer from '@modules/mobileManager/reducers';
import virtualHelpReducer from '@modules/virtualHelp/reducers';
import conferenceRedeucer from '@reducers/conference';
import conferencingReducer from '@modules/conferencing/reducers';

import globalReducer from './global';
import toastReducer from './toast';
import equityFinderReducer from './equityFinder';
import maintenanceReducer from './maintenance';
import appraisalDemoReducer from './appraisalDemo';

/**
 * The application's main reducer
 */
const rootReducer = combineReducers({
  app: appReducer,
  appraisal: appraisalReducer,
  appraisalDemo: appraisalDemoReducer,
  bi: biReducer,
  ci: ciReducer,
  equityFinder: equityFinderReducer,
  events: eventsReducer,
  global: globalReducer,
  maintenance: maintenanceReducer,
  sketch: sketchReducer,
  litigation: litigationReducer,
  mra: mraReducer,
  toast: toastReducer,
  assessment: assessmentReducer,
  appraisalAdmin: appraisalAdminReducer,
  processManager: processManagerReducer,
  analysis: analysisReducer,
  dataCapture: dataCaptureReducer,
  audits: auditsReducer,
  appeals: appealsReducer,
  queue: queueReducer,
  mobile: mobileReducer,
  virtualHelp: virtualHelpReducer,
  conference: conferenceRedeucer,
  conferencing: conferencingReducer,
});

export default rootReducer;
